import customFetch from "../helpers/customFetch";
import { API_URL, getConfigExactian } from "../helpers/helpers";

export const getAllResourcesInPlaceByOpennings = async (openingId = null, buildingId = null, resourcesTypes = []) => {
    const openingIdQuery = openingId !== '' ? `&openingId=${openingId}` : '';
    const buildingIdQuery = buildingId !== '' ? `&buildingId=${buildingId}` : '';
    const resourcesTypesQuery = resourcesTypes.length ? `&resourcesTypes=${resourcesTypes}` : [];

    try {
        const configs = getConfigExactian('GET');
        const response = await customFetch(`${API_URL}resourcesByOpening?${openingIdQuery}${buildingIdQuery}${resourcesTypesQuery}`, configs);
        const resData = await response.json();
        if (!response.ok) {
            return {
                ok: false,
                data: resData
            }
        } else {

            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}
export const getAllResourcesInPlaceByBuilding = async (openingId = null, buildingId = null, resourcesTypes = []) => {
    try {
        const openingIdQuery = openingId !== '' ? `&openingId=${openingId}` : '';
        const buildingIdQuery = buildingId !== '' ? `&buildingId=${buildingId}` : '';
        const resourcesTypesQuery = resourcesTypes.length ? `&resourcesTypes=${resourcesTypes}` : [];

        const configs = getConfigExactian('GET');
        const response = await customFetch(`${API_URL}resourcesByBuilding?${openingIdQuery}${buildingIdQuery}${resourcesTypesQuery}`, configs);
        const resData = await response.json();
        if (!response.ok) {
            return {
                ok: false,
                data: resData
            }
        } else {

            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}

export const getAllResourcesInPlaceByAreas = async (buildingId = null) => {
    try {
        const buildingIdQuery = buildingId !== '' ? `&buildingId=${buildingId}` : '';

        const configs = getConfigExactian('GET');
        const response = await customFetch(`${API_URL}resourcesByArea?${buildingIdQuery}`, configs);
        const resData = await response.json();
        if (!response.ok) {
            return {
                ok: false,
                data: resData
            }
        } else {

            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}

export const getAllResourcesInPlaceByHours = async (openingId = '', buildingId = '') => {
    try {
        const openingIdValue = openingId === '' ? '' : `&openingId=${openingId}`;
        const buildingIdValue = buildingId === '' ? '' : `&buildingId=${Number(buildingId)}`;

        const configs = getConfigExactian('GET');
        const response = await customFetch(`${API_URL}resourcesByHours?${openingIdValue}${buildingIdValue}`, configs);
        const resData = await response.json();
        if (!response.ok) {
            return {
                ok: false,
                data: resData
            }
        } else {

            return {
                ok: true,
                data: resData
            }
        }
    } catch (error) {
        console.log(error)
    }
}